import React, { Component }         from "react";
import { FontAwesomeIcon }          from '@fortawesome/react-fontawesome'
import { Button, Modal }            from "react-bootstrap";
import LoaderButton                 from "../../components/LoaderButton";
import { getUserProfileValidation } from "../../utils/AwsInvoke";
import { WhiteLabel }               from "../../utils/WhiteLabelProps";
//import "../../css/modal/ModalHeroInfo.css";

var white_label = WhiteLabel();
const MainColor = white_label.company_primary_btn_color;
const CloseBtnColor = white_label.company_close_btn_color;

export default class ModalHeroInfo extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            showModalSimple: false,
            subscribeBtn: "Subscribe",
            submitBtnDisabled: false
        };
    }

    createMarkup(text) { return {__html: text}; };

    handleSubmit = async event => {
            this.setState({
                isLoading: true
            })
            var mktplc_id  = this.props.marketplaceId;
            var program_id = this.props.programId;

            this.props.handleSubscribeToMktplcProgram(program_id, mktplc_id);
      }

    static getDerivedStateFromProps(props, state) {
       if (props.programSubscribed !== state.programSubscribed) {
           // Close modal
           if(props.programSubscribed) props.onHide();
       }

       return null;
    }

    render() {

        return (
            <Modal
                show={this.props.show}
                onHide={this.props.onHide}
                style={{position:"absolute", top:50, height: "100%"}}
              >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title" className="marketplaceModalTitle">
                        Exercise Programs
                            { /*}<FontAwesomeIcon icon="sticky-note" />*/ }
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  { /*}<span>
                      <img src={this.props.programImage} className="marketplaceModalProgramImageLarge"/>
                  </span>*/ }
                  <div className="marketplaceModalProgramSummary">
                      Exercise is one of the best modalities for longevity, productivity, and happiness
                      by means of enhancing brain, connective tissue, and cardiopulmonary health.  The
                      programs below will efficiently guide you through optimized routines at your desk,
                      home, or gym. Whether you have limited time or are dedicated to a full workout,
                      we have something to help you increase your healthspan, well-being, and cognitive
                      and physical performance.
                      <br/><br/>
                      The programs below are suggestions, guidance, and information to optimize the
                      aforementioned biological structures and qualities in preventative fashion.
                      The programs are not medical advice or prescription for your individual needs.
                      You can read more in our <a href="/tosauth"><b>terms of service</b></a>.
                      <br/><br/>
                      <i>If you would like customized exercise prescription by our health, fitness,
                      and/or medical provider partners please inquire with <a href="https://acceleratesp.typeform.com/to/shfKxY" target="_blank"><b>this form</b></a></i>.
                  </div>
                </Modal.Body>
                <Modal.Footer>
                      <LoaderButton
                          bsSize   = "large"
                          height   = "38px"
                          width    = "100px"
                          fontSize = "17px"
                          type     = "submit"
                          btncolor = { CloseBtnColor }
                          text     = "Close"
                          onClick     = {this.props.onHide}
                          loadingText = "Closing …"
                        />
                </Modal.Footer>
              </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalHeroInfo.js